/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MailTemplate,
    MailTemplateFromJSON,
    MailTemplateToJSON,
    Purpose,
    PurposeFromJSON,
    PurposeToJSON,
} from '../models';

export interface CreateMailTemplateRequest {
    mailTemplate: MailTemplate;
}

export interface DeleteMailTemplateRequest {
    id: number;
}

export interface DownMailTemplateRequest {
    id: number;
}

export interface LoadMailTemplatesRequest {
    purposeId?: number;
}

export interface LoadMailTemplatesByCodeRequest {
    purposeCode?: string;
}

export interface UpMailTemplateRequest {
    id: number;
}

export interface UpdateMailTemplateRequest {
    id: number;
    mailTemplate: MailTemplate;
}

/**
 * 
 */
export class AdminMailTemplatesApi extends runtime.BaseAPI {

    /**
     * メールテンプレート作成
     */
    async createMailTemplateRaw(requestParameters: CreateMailTemplateRequest): Promise<runtime.ApiResponse<MailTemplate>> {
        if (requestParameters.mailTemplate === null || requestParameters.mailTemplate === undefined) {
            throw new runtime.RequiredError('mailTemplate','Required parameter requestParameters.mailTemplate was null or undefined when calling createMailTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/mail-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MailTemplateToJSON(requestParameters.mailTemplate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MailTemplateFromJSON(jsonValue));
    }

    /**
     * メールテンプレート作成
     */
    async createMailTemplate(mailTemplate: MailTemplate): Promise<MailTemplate> {
        const response = await this.createMailTemplateRaw({ mailTemplate: mailTemplate });
        return await response.value();
    }

    /**
     * メールテンプレート削除
     */
    async deleteMailTemplateRaw(requestParameters: DeleteMailTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteMailTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mail-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メールテンプレート削除
     */
    async deleteMailTemplate(id: number): Promise<void> {
        await this.deleteMailTemplateRaw({ id: id });
    }

    /**
     * メールテンプレート下に移動
     */
    async downMailTemplateRaw(requestParameters: DownMailTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling downMailTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mail-templates/{id}/down`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メールテンプレート下に移動
     */
    async downMailTemplate(id: number): Promise<void> {
        await this.downMailTemplateRaw({ id: id });
    }

    /**
     * メールテンプレート取得, 承認者以外が使う部分
     */
    async loadMailTemplatesRaw(requestParameters: LoadMailTemplatesRequest): Promise<runtime.ApiResponse<Array<MailTemplate>>> {
        const queryParameters: any = {};

        if (requestParameters.purposeId !== undefined) {
            queryParameters['purposeId'] = requestParameters.purposeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mail-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailTemplateFromJSON));
    }

    /**
     * メールテンプレート取得, 承認者以外が使う部分
     */
    async loadMailTemplates(purposeId?: number): Promise<Array<MailTemplate>> {
        const response = await this.loadMailTemplatesRaw({ purposeId: purposeId });
        return await response.value();
    }

    /**
     * メールテンプレート取得, 承認者以外が使う部分
     */
    async loadMailTemplatesByCodeRaw(requestParameters: LoadMailTemplatesByCodeRequest): Promise<runtime.ApiResponse<Array<MailTemplate>>> {
        const queryParameters: any = {};

        if (requestParameters.purposeCode !== undefined) {
            queryParameters['purposeCode'] = requestParameters.purposeCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mail-templates/by-code`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MailTemplateFromJSON));
    }

    /**
     * メールテンプレート取得, 承認者以外が使う部分
     */
    async loadMailTemplatesByCode(purposeCode?: string): Promise<Array<MailTemplate>> {
        const response = await this.loadMailTemplatesByCodeRaw({ purposeCode: purposeCode });
        return await response.value();
    }

    /**
     * メールテンプレート目的取得, 承認者以外が使う部分
     */
    async loadMailTemplatesPurposesRaw(): Promise<runtime.ApiResponse<Array<Purpose>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mail-templates/purposes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PurposeFromJSON));
    }

    /**
     * メールテンプレート目的取得, 承認者以外が使う部分
     */
    async loadMailTemplatesPurposes(): Promise<Array<Purpose>> {
        const response = await this.loadMailTemplatesPurposesRaw();
        return await response.value();
    }

    /**
     * メールテンプレート上に移動
     */
    async upMailTemplateRaw(requestParameters: UpMailTemplateRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling upMailTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/admin/mail-templates/{id}/up`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * メールテンプレート上に移動
     */
    async upMailTemplate(id: number): Promise<void> {
        await this.upMailTemplateRaw({ id: id });
    }

    /**
     * メールテンプレート更新
     */
    async updateMailTemplateRaw(requestParameters: UpdateMailTemplateRequest): Promise<runtime.ApiResponse<MailTemplate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateMailTemplate.');
        }

        if (requestParameters.mailTemplate === null || requestParameters.mailTemplate === undefined) {
            throw new runtime.RequiredError('mailTemplate','Required parameter requestParameters.mailTemplate was null or undefined when calling updateMailTemplate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/admin/mail-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MailTemplateToJSON(requestParameters.mailTemplate),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MailTemplateFromJSON(jsonValue));
    }

    /**
     * メールテンプレート更新
     */
    async updateMailTemplate(id: number, mailTemplate: MailTemplate): Promise<MailTemplate> {
        const response = await this.updateMailTemplateRaw({ id: id, mailTemplate: mailTemplate });
        return await response.value();
    }

}
